import { subDays, addDays } from 'date-fns';
import { Document, DocumentType, FileStatus } from './Document.interface';
import { users } from '../../user/User.mocks';

export const documents: Document[] = [
  {
    id: 7,
    type: DocumentType.Folder,
    name: 'HIPAA',
    modified: subDays(new Date(), 10),
    modifiedBy: users[6],
    documents: [
      {
        id: 6,
        type: DocumentType.File,
        name: 'HIPAA Security Policy',
        version: 1,
        modified: subDays(new Date(), 3),
        assigned: subDays(new Date(), 3),
        dueDate: addDays(new Date(), 5),
        modifiedBy: users[1],
        assignedTo: users[1],
        history: [
          {
            version: 1,
            status: FileStatus.Draft,
            created: subDays(new Date(), 3),
            createdBy: 'Ashoi Patel'
          }
        ]
      }
    ]
  },
  {
    id: 1,
    type: DocumentType.File,
    name: 'SOP-101 Change Control for Computer Systems',
    version: 1,
    modified: subDays(new Date(), 10),
    assigned: subDays(new Date(), 10),
    dueDate: addDays(new Date(), 1),
    modifiedBy: users[6],
    assignedTo: users[6],
    history: [
      {
        version: 1,
        status: FileStatus.Draft,
        created: subDays(new Date(), 10),
        createdBy: 'Kelly Chu'
      },
      {
        version: 1,
        status: FileStatus.Draft,
        created: subDays(new Date(), 11),
        createdBy: 'Kelly Chu'
      }
    ]
  },
  {
    id: 2,
    type: DocumentType.File,
    name: 'SOP-110 Cloud Infrastructure Management',
    version: 1,
    modified: subDays(new Date(), 5),
    assigned: subDays(new Date(), 5),
    dueDate: addDays(new Date(), 2),
    modifiedBy: users[8],
    assignedTo: users[8],
    history: [
      {
        version: 1,
        status: 'in-review',
        created: subDays(new Date(), 5),
        createdBy: 'Charton Sapinoso'
      },
      {
        version: 1,
        status: 'draft',
        created: subDays(new Date(), 10),
        createdBy: 'Kelly Chu'
      },
      {
        version: 1,
        status: 'to-do',
        created: subDays(new Date(), 11),
        createdBy: 'Kelly Chu'
      }
    ]
  },
  {
    id: 4,
    type: DocumentType.File,
    name: 'Incident Defect Tracking',
    version: 1,
    url:
      'http://localhost:3000/api/files?key=documents%2Ffc49f4bc-309e-49ad-8d59-4e7b7441bd02.pdf',
    modified: subDays(new Date(), 4),
    assigned: subDays(new Date(), 4),
    modifiedBy: users[1],
    assignedTo: users[1],
    history: [
      {
        version: 1,
        status: 'in-review',
        created: subDays(new Date(), 4),
        createdBy: 'Ashoi Patel'
      },
      {
        version: 1,
        status: 'draft',
        created: subDays(new Date(), 10),
        createdBy: 'Kelly Chu'
      },
      {
        version: 1,
        status: 'to-do',
        created: subDays(new Date(), 11),
        createdBy: 'Kelly Chu'
      }
    ]
  },
  {
    id: 5,
    type: DocumentType.File,
    name: 'Electronic Signatures',
    version: 1,
    modified: subDays(new Date(), 4),
    assigned: subDays(new Date(), 4),
    modifiedBy: users[1],
    assignedTo: users[1],
    history: [
      {
        version: 1,
        status: 'approved',
        created: subDays(new Date(), 4),
        createdBy: 'Ashoi Patel'
      },
      {
        version: 1,
        status: 'in-review',
        created: subDays(new Date(), 5),
        createdBy: 'Ashoi Patel'
      },
      {
        version: 1,
        status: 'draft',
        created: subDays(new Date(), 10),
        createdBy: 'Kelly Chu'
      },
      {
        version: 1,
        status: 'to-do',
        created: subDays(new Date(), 11),
        createdBy: 'Kelly Chu'
      }
    ]
  },
  {
    id: 3,
    type: DocumentType.File,
    name: 'GxP and 21 CFR Part 11 Assessment',
    version: 1,
    modified: subDays(new Date(), 3),
    assigned: subDays(new Date(), 3),
    modifiedBy: users[1],
    assignedTo: users[1],
    history: [
      {
        version: 1,
        status: 'approved',
        created: subDays(new Date(), 3),
        createdBy: 'Ashoi Patel'
      },
      {
        version: 1,
        status: 'in-review',
        created: subDays(new Date(), 3),
        createdBy: 'Ashoi Patel'
      },
      {
        version: 1,
        status: 'draft',
        created: subDays(new Date(), 10),
        createdBy: 'Kelly Chu'
      },
      {
        version: 1,
        status: 'to-do',
        created: subDays(new Date(), 11),
        createdBy: 'Kelly Chu'
      }
    ]
  }
];
